<div>
  <div id="myReportContainer" #reportContainer class="power-bi-frame" style="height: 800px">{{ message | translate }}</div>
</div>
